import type { QrCode, QrCodeKind } from './api/types';

/** What a code is to a reader. A vCard short link is stored as a link code, but nobody reads it as one. */
export type CodeType = QrCodeKind | 'VCard';

export const CODE_TYPES: readonly CodeType[] = ['Destination', 'VCard', 'Product', 'File'];

const LABEL_KEYS: Record<CodeType, string> = {
  Destination: 'qrCode.kindDestination',
  VCard: 'qrCode.kindVCard',
  Product: 'qrCode.kindProduct',
  File: 'qrCode.kindFile',
};

const ICONS: Record<CodeType, string> = {
  Destination: 'pi-globe',
  VCard: 'pi-id-card',
  Product: 'pi-box',
  File: 'pi-file',
};

export function codeTypeOf(qrCode: Pick<QrCode, 'kind' | 'contact'>): CodeType {
  return qrCode.contact ? 'VCard' : qrCode.kind;
}

export function codeTypeLabel(type: CodeType, t: (key: string) => string): string {
  return t(LABEL_KEYS[type]);
}

export function codeTypeIcon(type: CodeType): string {
  return ICONS[type];
}
